/**
 * Wholesale Admin API Service
 *
 * تمام endpoint های wholesale برای admin panel.
 * Backend mount: /api/wholesale/admin/*
 */

import apiClient from './api';

// ─── Types ───
export type AdminSettingLevel = 'L1' | 'L2' | 'L3';
export type AdminSettingValueType = 'number' | 'string' | 'boolean' | 'json' | 'enum';

export interface WholesaleAdminSetting {
  _id: string;
  key: string;
  namespace: string;
  valueType: AdminSettingValueType;
  value: any;
  defaultValue: any;
  displayName: string;
  description?: string;
  level: AdminSettingLevel;
  category: string;
  minValue?: number;
  maxValue?: number;
  enumValues?: string[];
  displayOrder: number;
  isActive: boolean;
  lastModifiedAt?: string;
  lastModifiedBy?: string;
}

export interface PlatformAccountSummary {
  _id: string;
  accountType: string;
  displayName: string;
  balance: number;
  isActive: boolean;
}

export interface WholesaleStats {
  pools: { total: number; active: number };
  items: { total: number; available: number; sold: number };
  listings: number;
  resellers: number;
}

export interface HealthcheckResponse {
  status: string;
  platformAccounts: PlatformAccountSummary[];
  adminSettings: number;
  enabled: boolean;
}

// ─── Endpoints ───
// نکته: apiClient (./api) خودش response.data رو unwrap می‌کنه و مستقیم T برمی‌گردونه
const wholesaleService = {
  // Public
  async healthcheck(): Promise<HealthcheckResponse> {
    return await apiClient.get<HealthcheckResponse>('/wholesale/healthcheck');
  },

  // Admin settings
  async getAllSettings(): Promise<WholesaleAdminSetting[]> {
    const data = await apiClient.get<{ settings: WholesaleAdminSetting[] }>(
      '/wholesale/admin/settings'
    );
    return data.settings;
  },

  async updateSetting(key: string, value: any, reason?: string): Promise<void> {
    await apiClient.put(`/wholesale/admin/settings/${encodeURIComponent(key)}`, {
      value,
      reason,
    });
  },

  // Stats
  async getStats(): Promise<WholesaleStats> {
    return await apiClient.get<WholesaleStats>('/wholesale/admin/stats');
  },
};

export default wholesaleService;
